export default __webpack_public_path__ + "asset/img/logo~07b89d52.png";